"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCarouselHeadingArea = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var StyledCarouselHeadingArea = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledCarouselHeadingArea",
  componentId: "c11n-8-107-0__sc-1uioglg-0"
})([""]);
exports.StyledCarouselHeadingArea = StyledCarouselHeadingArea;